import React from 'react'

import icon_addText from '../i/add_text.svg'
import icon_addImg from '../i/add_img.svg'
import icon_addFlip from '../i/add_flip.svg'
import icon_addEmbed from '../i/add_embed.svg'
import icon_more from '../i/more.svg'

class Add extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.onButtonClick = this.onButtonClick.bind(this)
    }

    onButtonClick(evt) {
        const { onAdd, id } = this.props
        if (onAdd) {
            onAdd(parseInt(evt.currentTarget.getAttribute('datat')), id)
        }
    }

    render() {
        return (
            <div className="add">
                <span className="block_button" onClick={this.onButtonClick} datat="1">
                    <img src={icon_addText}></img>
                    Add text
                </span>
                <span className="block_button" onClick={this.onButtonClick} datat="2">
                    <img src={icon_addImg}></img>
                    Add image
                </span>
                <span className="block_button" onClick={this.onButtonClick} datat="4">
                    <img src={icon_addFlip}></img>
                    Add Flip
                </span>
                <span className="block_button" onClick={this.onButtonClick} datat="3">
                    <img src={icon_addEmbed}></img>
                    Embed Interacty project
                </span>
                <span className="block_button __blue" onClick={this.onButtonClick} datat="0">
                    <img src={icon_more}></img>
                    All options
                </span>
            </div>
        )
    }
}

export default Add
